import styled from '@emotion/styled'
import { styles } from 'app/theme'
import { Link } from 'gatsby'
import React, { memo } from 'react'

export interface Props {
  languageCode?: string
  title: string
  URL: string
}

export const MenuItem = memo(function MenuItem({ title, URL }: Props) {
  if (!title || !URL) {
    return null
  }

  return URL ? (
    <Anchor to={URL} activeClassName="active">
      <Inner>{title}</Inner>
    </Anchor>
  ) : null
})

const Inner = styled.span`
  transition: 0.3s ease-in-out;
`

const Anchor = styled(Link)`
  ${styles.description.light}

  display: inline-flex;
  align-items: center;

  &:hover {
    ${Inner} {
      opacity: 0.5;
    }
  }
`
